export enum StatusCodes {
	NO_CONTENT = 204,
}
